import React, { useState, useEffect, useRef } from "react";
import "./tableStyle.css";
import { getDoData, updateDo } from "../../Services/Services";
import { Col, Input, Button, Radio, Form, Modal, message } from "antd";
import DoEntry from "./DoEntry";
import Header from "../Header-Footer/Header";
import { useReactToPrint } from "react-to-print";
import Footer from "../Header-Footer/Footer";
import * as XLSX from "xlsx"; // Import xlsx library
import { Link } from "react-router-dom";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
export default function DetailsDoNo() {
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [orderList, setorderList] = useState([]);
  const [filterdono, setFilterdono] = useState("");
  const [filterClientName, setFilterClientName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [doId, setDoId] = useState(null);
  const [form] = Form.useForm();
  useEffect(() => {
    GetDo();
  }, []);

  const GetDo = async () => {
    const response = await getDoData({
      com_name: localStorage.getItem("com_name"),
    });
    if (response) {
      const sortedArray = [...response].sort((a, b) => b.id - a.id);
      setDeliveryOrder(sortedArray);
      setorderList(sortedArray);
    }
  };
  useEffect(() => {
    setDeliveryOrder(
      orderList.filter((res) =>
        res.client_name.toLowerCase().includes(filterClientName.toLowerCase())
      )
    );
  }, [filterClientName]);
  useEffect(() => {
    setDeliveryOrder(
      orderList.filter((res) =>
        res.do_no.toLowerCase().includes(filterdono.toLowerCase())
      )
    );
  }, [filterdono]);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = deliveryOrder.map((e, index) => [
      index + 1,
      e.client_name,
      e.do_no,
      e.mines_name,
      e.do_start_date,
      e.do_end_date,
      e.quantity,
      e.dis_qty,
      e.rem_qty,
      e.total_advance_paid,
      e.advance_amt,
      parseFloat(e.total_advance_paid) - parseFloat(e.advance_amt),
      e.paid_amt,
      e.rem_qty != 0 ? "Pending" : "Complete",
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        "Sr.No",
        "Party Name",
        "Do No.",
        "Mines Name",
        "DO Start Date",
        "DO End Date",
        "Total Qty",
        "Dispatch Qty",
        "Balance Qty",
        "Debit Amt",
        "Credit Amt",
        "Balance Amt",
        "Total Freight Amt",
        "Lifting Status",
      ],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, "DeliveryOrder");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, "DeliveryOrder.xlsx");
  };
  const searchFilter = (value) => {
    if (value) {
      const filteredArray = orderList.filter((item) => item.rem_qty === 0);
      setDeliveryOrder(filteredArray);
    } else if (value === "") {
      setDeliveryOrder(orderList);
    } else {
      const filteredArray = orderList.filter((item) => item.rem_qty != 0);
      setDeliveryOrder(filteredArray);
    }
  };
  const showModal = (do_id) => {
    setDoId(do_id);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const onFinish = async (values) => {
    Object.assign(values, { com_name: localStorage.getItem("com_name") });
    const response = await updateDo(doId, values);
    if (response) {
      message.success("DO Update Successful");
      setIsModalOpen(false);
      form.resetFields();
      const sortedArray = [...response].sort((a, b) => b.id - a.id);
      setDeliveryOrder(sortedArray);
      setorderList(sortedArray);
    } else {
      message.warning("DO Update Not Successful");
    }
  };
  const formateDate = (date) => {
    const [year, month, day] = date.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };

  return (
    <div style={{ height: "90vh" }}>
      <Header heading="DELIVERY ORDER VIEW" />
      <Modal
        visible={isModalOpen} // Correct prop name is visible, not open
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={200}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="type"
            label={<b>Select</b>}
            rules={[
              {
                required: true,
                message: "Please Select!",
              },
            ]}
          >
            <Radio.Group
              defaultValue={""}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Radio value="Sell">
                <b>Sale</b>
              </Radio>
              <Radio value="Leps">
                <b>Leps</b>
              </Radio>
              <Radio value="Complete">
                <b>Complete</b>
              </Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            className="text-center"
            style={{ textAlign: "center", padding: "0px", margin: "2px" }}
          >
            <Button
              htmlType="submit"
              style={{ color: "white", backgroundColor: "black" }}
            >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <div
        className=" grid grid-cols-1 sm:grid sm:grid-cols-4 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%]"
        style={{ marginBottom: "10px" }}
      >
        <Col>
          <label>
            <b>Search By Do No.</b>
          </label>
          <br />
          <Input
            placeholder="Search by DO No."
            value={filterdono}
            onChange={(e) => setFilterdono(e.target.value)}
          />
        </Col>
        <Col>
          <label>
            <b>Search By Party Name</b>
          </label>
          <br />
          <Input
            placeholder="Search by Party Name."
            value={filterClientName}
            onChange={(e) => setFilterClientName(e.target.value)}
          />
        </Col>
        <Col>
          <label>
            <b>Lifting Status </b>
          </label>
          <Radio.Group defaultValue={""}>
            <Radio value={false} onChange={(e) => searchFilter(false)}>
              Pending
            </Radio>
            <Radio value={true} onChange={(e) => searchFilter(true)}>
              Complete
            </Radio>
            <Radio value={""} onChange={(e) => searchFilter("")}>
              All
            </Radio>
          </Radio.Group>
        </Col>

        <Col>
          <DoEntry
            setDeliveryOrder={setDeliveryOrder}
            setorderList={setorderList}
          />
          <Button
            style={{
              bottom: "-5px",
              margin: "10px",
              backgroundColor: "black",
              color: "white",
              fontWeight: "600",
            }}
            onClick={handlePrint}
          >
            <FaFilePdf />
          </Button>
        </Col>
      </div>
      <div className="table-wrapper-2" ref={componentRef} style={{ maxHeight: "500px", overflowX: "auto", overflowY: "auto" }}>
        <table id="my-table" className="w-full">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Sr. No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Party Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Do Id
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Do No.
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Mines Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                DO Start Date
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                DO End Date
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Total Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Dispatch Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Balance Qty
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Debit Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Credit Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Balance Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Total Freight Amt
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Lifting Status
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Leps/Sale
              </th>
            </tr>
          </thead>
          <tbody>
            {deliveryOrder.map((e, index) => (
              <tr
                key={e.index}
                style={{ backgroundColor: e.rem_qty === 0 ? "#b8ebb8" : "" }}
              >
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {index + 1}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.client_name}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.id}
                </td>

                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <Link to={`/do-view/${e.id}`}>
                    <u style={{ fontWeight: "600", color: "blue" }}>
                      {e.do_no}
                    </u>
                  </Link>
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.mines_name}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {formateDate(e.do_start_date)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {formateDate(e.do_end_date)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.quantity}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.dis_qty.toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.rem_qty.toFixed(3)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <Link to={`/pay-view/${e.id}`}>
                    <u style={{ fontWeight: "600", color: "blue" }}>
                      {e.total_advance_paid}
                    </u>
                  </Link>
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <Link to={`/do-view/${e.id}`}>
                    <u style={{ fontWeight: "600", color: "blue" }}>
                      {e.advance_amt}
                    </u>
                  </Link>
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {parseFloat(e.total_advance_paid) - parseFloat(e.advance_amt)}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <Link to={`/do-view/${e.id}`}>
                    <u style={{ fontWeight: "600", color: "blue" }}>
                      {e.paid_amt}
                    </u>
                  </Link>
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.rem_qty != 0 ? "Pending" : "Complete"}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.is_sell || e.is_leps ? (
                    <>
                      {e.is_sell ? (
                        <>Sale - {e.sell_qty.toFixed(3)}</>
                      ) : (
                        <>Leps - {e.leps_qty.toFixed(3)}</>
                      )}
                    </>
                  ) : (
                    <Button
                      size="small"
                      style={{
                        backgroundColor: e.rem_qty != 0 ? "black" : "",
                        color: e.rem_qty != 0 ? "white" : "black",
                      }}
                      disabled={e.rem_qty != 0 ? false : true}
                      onClick={() => showModal(e.id)}
                    >
                      Click
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
